import { router } from "expo-router";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ScrollView, View } from "react-native";
import { useDispatch } from "react-redux";

import { loginHandler } from "../Login";

import Logo from "@/assets/logo.svg";
import Copyright from "@/components/Copyright";
import Title from "@/components/Title";
import ButtonLogout from "@/components/button/ButtonLogout";
import Card from "@/components/card/Card";
import { setForm } from "@/context/actions/actions";
import { useAppSelector } from "@/context/hooks";
import { storage } from "@/context/storage";
import { sendRequest } from "@/utils/ApiUtil";

export default function Welcome() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [formsType, setFormsType] = useState("");
  const states = useAppSelector((state: any) => state);

  useEffect(() => {
    const createApplication = async () => {
      const data = {
        termsAndConditionsAccepted: true,
        applicationType: formsType,
      };

      try {
        const login = await loginHandler({
          email: states.email,
          password: states.password,
        });

        if (login) {
          const response = await sendRequest(
            "post",
            "/create-application",
            data,
            true
          );
          if (response) {
            const loginAgain = await loginHandler({
              email: states.email,
              password: states.password,
            });
            if (loginAgain) {
              storage.set("user.auth.applicationId", response.applicationId);
              storage.set("user.auth.applicationType", formsType);

              dispatch(setForm({ email: null, password: null }));
              router.replace("/getready");
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (formsType !== "") {
      createApplication();
    }
  }, [formsType]);

  const handleSelect = (type: string) => {
    setFormsType(type);
  };

  return (
    <ScrollView contentContainerClassName="flex-grow bg-white1">
      <View className="z-50 absolute top-0 right-0 m-8">
        <ButtonLogout />
      </View>
      <View className="items-center justify-center w-full h-full">
        <Logo className="m-2" />
        <View className="m-2">
          <Title text={t("onboarding/welcome:title")} />
        </View>
        <View className="flex-grow flex-col justify-center w-full items-center lg:flex-row">
          <Card
            title={t("onboarding/welcome:card.individual.title")}
            body={t("onboarding/welcome:card.individual.body")}
            isSelected={formsType === "INDIVIDUAL"}
            onPress={() => handleSelect("INDIVIDUAL")}
          />
          <Card
            title={t("onboarding/welcome:card.corporation.title")}
            body={t("onboarding/welcome:card.corporation.body")}
            isSelected={formsType === "CORPORATION"}
            onPress={() => handleSelect("CORPORATION")}
          />
        </View>
        <View className="flex-grow justify-end">
          <Copyright />
        </View>
      </View>
    </ScrollView>
  );
}
